import React from "react";

import { TextDoc } from "src/common/components/TextDoc";

export const HtxToc: React.FunctionComponent = () => (
	<TextDoc>
		<section>
			<h1>VÉGFELHASZNÁLÓI SZERZŐDÉS</h1>
			<p>
				amely létrejött egyrészről a{" "}
				<b>Neumann Medical Korlátolt Felelősségű Társaság</b>{" "}
				(székhelye: 1024 Budapest, Buday László u 12., cégjegyzékszám:
				01-09-694439, adószám: 12602128-2-42, képviseli: Dr. Dietz
				Gergely ügyvezető önállón), mint szolgáltató (a továbbiakban:{" "}
				<b>Neumann Medical Kft.</b> vagy <b>Szolgáltató</b>), másrészről
				a „FYRMS Strukturált Egészségügyi Portál – Szívtranszplantációs
				Döntéstámogató Modul” rendszer szolgáltatásait igénybevevő (mint
				felhasználó) (a továbbiakban: <b>Felhasználó</b>) között (a
				továbbiakban együttesen: Szerződő Felek)
			</p>

			<h2 className="li li--1">Bevezetés</h2>
			<p>
				Jelen szerződésben a Felek a szívtranszplantációk
				pretranszplantációs szakaszában végzett tevékenység
				elősegítésére szolgáló együttműködésüket szabályozzák.
			</p>

			<h2 className="li li--1">Felhasználók és Szolgáltatás:</h2>
			<p className="li li--2">
				A Szerződő Felek rögzítik, hogy a Felhasználó megfeleltethető az
				alábbi felsorolás valamely elemének:
			</p>
			<p className="li li--3">
				a várólista alapján nyújtható ellátások részletes szabályairól
				szóló 287/2006. (XII.23.) számú Kormányrendelet (a továbbiakban:
				Korm. rendelet) 3. § (2) bekezdés a) pontja szerinti Szív
				Transzplantációs Bizottság (a továbbiakban: Bizottság) által
				jóváhagyott, a végstádiumú szívelégtelenségben szenvedő betegek
				szívtranszplantációs ellátás elbírálására a Bizottság elé
				történő referálásra feljogosított orvosszakmai szereplő
			</p>
			<p className="li li--3">
				az a) pontban meghatározott személy szakmai segítője (pl.
				asszisztens)
			</p>
			<p className="li li--3">a Transzplantációs Bizottság tagja.</p>
			<p className="li li--2">
				A Szerződő Felek ugyancsak rögzítik, hogy a Neumann Medical Kft.
				kifejlesztett egy a szívtranszplantációra váró betegek személyes
				– és egészségügyi adatainak, egészségügyi dokumentációjának
				nyilvántartására szolgáló szoftvert („FYRMS Strukturált
				Egészségügyi Portál – Szívtranszplantációs Döntéstámogató
				Modul”, a továbbiakban: Szoftver), melynek célja a Felhasználó
				Bizottsággal történő kommunikációjának támogatása, adatok
				gyűjtése és továbbítása a transzplantációra való alkalmasság
				megállapításához.
			</p>
			<p className="li li--2">
				A 2. pont szerinti adatkezelés a transzplantációra váró beteg
				hozzájárulásával történik. A beteg a személyes adatok
				kezeléséhez az általa igénybe venni kívánt orvosi ellátásra
				tekintettel járul hozzá, az anonimizált adatok felhasználását
				pedig tudományos kutatási célokra engedélyezi.
			</p>
			<p className="li li--2">
				A Szerződő Felek rögzítik, hogy a Szoftver felhasználására az
				Országos Vérellátó Szolgálat transzplantációval kapcsolatos
				tevékenységétől függetlenül, azt megelőző szakaszban, az ún.
				pretranszplantációs szakaszban kerül sor.
			</p>

			<h2 className="li li--1">Felhasználói jogok:</h2>
			<p className="li li--2">
				A Szerződő Felek megállapodnak abban, hogy a Neumann Medical
				Kft., mint a Szoftver kizárólagos jogtulajdonosa, a Szoftverre
				vonatkozó nem kizárólagos és át nem ruházható felhasználói jogot
				biztosít a Felhasználó számára jelen szerződében foglaltak
				szerint.
			</p>
			<p className="li li--2">
				A Felhasználó kizárólag saját maga, és kizárólag a jelen
				megállapodásban rögzített célokra jogosult a Szoftvert
				használni. A Felhasználó a biztonsági mentéstől eltekintve nem
				jogosult a Szoftverről másolatot készíteni.
			</p>
			<p className="li li--2">
				A Szerződő Felek megállapodnak abban, hogy a Neumann Medical
				Kft. a felhasználói jogot a Felhasználók számára ingyenesen
				biztosítja.
			</p>

			<h2 className="li li--1">Felhasználói regisztráció</h2>
			<p className="li li--2">
				A Felhasználó regisztrációja a Bizottság jóváhagyását követően
				történik. A Felhasználó írásban igényli a Bizottságtól a
				hozzáférés biztosítását. Jóváhagyásával együtt a Bizottság
				írásban továbbítja a Felhasználó elérhetőségét a Szolgáltató
				részére.
			</p>
			<p className="li li--2">
				A Neumann Medical Kft. a Felhasználó elérhetőségeinek
				kézhezvételét követően legfeljebb 5 munkanapon belül a
				Felhasználó számára a hozzáférést biztosítja, illetve a
				felhasználói oktatást elvégzi (vagy Felhasználói Kézikönyvet
				átadja).
			</p>
			<p className="li li--2">
				A Felhasználó az első belépést követően köteles jelen
				Végfelhasználói szerződés feltételeit elfogadni.
			</p>
			<p className="li li--2">
				A Felhasználó hozzájárul ahhoz, hogy személyes adatait a
				Szolgáltató a rendszer üzemeltetésének céljából nyilvántartsa,
				és Adatkezelési szabályzatának megfelelően kezelje.
			</p>

			<h2 className="li li--1">A Szerződő Felek jogai és kötelességei</h2>
			<h3>A Szolgáltató jogai és kötelességei:</h3>
			<p className="li li--2">
				A Szerződő Felek megállapodnak abban, hogy a jelen megállapodás
				fennállása alatt a Szolgáltató ingyenesen szoftvertámogatási
				szolgáltatást nyújt a Felhasználó részére, amely az alábbi
				szolgáltatásokat foglalja magába: oktatás, felhasználói fiók
				karbantartása, rendszerüzemeltetés, hibajavítás,
				jogszabálykövetés.
			</p>
			<p className="li li--2">
				A Szolgáltató külön intézkedés nélkül jogosult felfüggeszteni a
				Felhasználó hozzáférési jogát, amennyiben azt a Bizottság
				írásban kéri.
			</p>
			<p className="li li--2">
				A Szolgáltató a 2011. évi CXII. törvény az információs
				önrendelkezési jogról és az információszabadságról (a
				továbbiakban: Infotörvény) és AZ EURÓPAI PARLAMENT ÉS A TANÁCS
				(EU) 2016/679 RENDELETE (2016. április 27.) a természetes
				személyeknek a személyes adatok kezelése tekintetében történő
				védelméről és az ilyen adatok szabad áramlásáról, valamint a
				95/46/EK rendelet hatályon kívül helyezéséről (általános
				adatvédelmi rendelet) (a továbbiakban: GDPR) rendelkezései
				szerint adatfeldolgozóként végzi tevékenységét. A Szolgáltató a
				Szoftverben tárolt adatokat (sem a Felhasználók sem az
				érintettek adatait) saját célra fel nem használhatja és harmadik
				félnek tovább nem adathatja. A Szolgáltató köteles az
				Infotörvény és a GDPR releváns rendelkezéseit maradéktalanul
				betartani. A Szolgáltató adatkezelési folyamatát Adatkezelői
				Szabályzata tartalmazza.
			</p>
			<h3>A Felhasználó jogai és kötelességei:</h3>
			<p className="li li--2">
				A Felhasználó jogosult az általa kezelt betegek adatait a
				rendszerben rögzíteni, a Bizottsághoz transzplantáció elbírálása
				céljából referálni, a betegek státuszát ellenőrizni, szükség
				esetén az adatokat módosítani (a bizottság által írásban
				meghatározott felhasználói jogkörön belül).
			</p>
			<p className="li li--2">
				A Felhasználó nem jogosult a Szoftver módosítására és/vagy
				továbbfejlesztésére. A Szoftvert a Felhasználó kizárólag saját
				célra használhatja, a felhasználói leírásban foglaltak betartása
				mellett. A Felhasználó nem jogosult a Szoftvert a Szolgáltató
				előzetes írásbeli engedélye nélkül harmadik személy használatába
				adni, illetve harmadik személynek felhasználási engedélyt nem
				adhat.
			</p>
			<p className="li li--2">
				A Felhasználó köteles megakadályozni, hogy illetéktelen személy
				a Szoftverhez hozzáférjen, a Szoftvert használja vagy lemásolja.{" "}
			</p>
			<p className="li li--2">
				A Felhasználó köteles a rendszerbe regisztrált új érintett
				vonatkozásában a szerződés mellékletét képező „Hozzájáruló
				Nyilatkozat Személyes Adatok Kezeléséhez” nyilatkozat
				kitöltésére és érintettekkel történő aláíratására. A Felhasználó
				kijelenti, hogy kizárólag abban az esetben rögzít személyes és
				egészségügyi adatokat a Szoftverben, ha az az érintett írásos
				beleegyezésével azt engedélyezte. A Szoftver használatának
				megkezdésekor a jelenleg a Bizottság elé referált betegek
				adatainak visszamenőleges rögzítése megtörténik a betegellátás
				folytonosságának biztosítása érdekében, azonban a Felhasználó
				ebben az esetben is köteles a lehető leghamarabb az
				érintettekkel a „Hozzájáruló Nyilatkozat Személyes Adatok
				Kezeléséhez” nyilatkozat aláíratására.
			</p>
			<p className="li li--2">
				A Szerződő Felek rögzítik, hogy a Transzplantációs Bizottság
				tagjai a jogszabályban meghatározott módon kutatási céllal
				kezelhetik az érintett betegek anonimizált adatait.
			</p>

			<h2 className="li li--1">Egyéb rendelkezések</h2>
			<p className="li li--2">
				A jelen megállapodás határozatlan időre jön létre Felhasználó a
				„FYRMS Strukturált Egészségügyi Portál – Szívtranszplantációs
				Döntéstámogató Modul” rendszer első használatbavételéének és
				jelen Szerződés feltételeinek elfogadásának dátumával.
			</p>
			<p className="li li--2">
				A jelen Szerződést a Felek egyező akarattal bármikor
				megszüntethetik. A Szerződő Felek megállapodnak abban, hogy a
				megállapodást bármelyik fél egyoldalú írásos jognyilatkozattal
				30 napos felmondási idővel felmondhatja.
			</p>
			<p className="li li--2">
				A Szerződő Felek megállapodnak abban, hogy a Szolgáltató a
				megállapodást a Felhasználósúlyos szerződésszegése esetén
				azonnali hatállyal jogosult felmondani. Súlyos
				szerződésszegésnek minősül, ha a Felhasználó a jelen
				megállapodás 3.2. pontjában foglalt rendelkezést megszegik.
			</p>
			<p className="li li--2">
				A 2.1. b) pontban rögzített személy köteles bejelenteni, ha a
				2.1. a) pontban rögzített személlyel megszűnik a szerződése, így
				nem végez a jelen megállapodás hatálya alá tartozó
				tevékenységet.
			</p>
			<p className="li li--2">
				Jelen megállapodás kizárólag írásban, a Felek egyező akaratával
				módosítható.
			</p>
			<p className="li li--2">
				A Neumann Medical Kft. nem garantálja, hogy a Szoftver teljesen
				hibátlan vagy bárminemű zavar nélkül működik. A Neumann Medical
				Kft. kizárja a felelősségét olyan károk megtérítéséért, amelyek
				a Szoftver használatából vagy nem használhatóságából erednek.
			</p>
			<p className="li li--2">
				A Szerződő Felek rögzítik, hogy amennyiben a Felhasználó a
				Transzplantációs Bizottság tagja, úgy valamennyi beteg adatát
				jogosult megismerni és kezelni. Amennyiben a Felhasználó a
				szívtranszplantációs ellátás elbírálására a Transzplantációs
				Bizottság elé történő referálásra feljogosított „orvosszakmai
				szereplő” úgy kizárólag az általa kezelt beteg rögzített adatait
				jogosult megismerni és kezelni. Amennyiben a Felhasználó a 2.1.
				b) pont szerinti személy úgy kizárólag azon „orvosszakmai
				szereplő” által kezelt beteg adatait jogosult megismerni és
				kezelni, akinek a munkáját segíti.
			</p>
			<p className="li li--2">
				Jelen megállapodásban nem szabályozott kérdésekben a Polgári
				Törvénykönyvről szóló 2013. évi V. törvény rendelkezéseit kell
				alkalmazni.
			</p>
			<p>
				Jelen megállapodást a Szerződő Felek elolvasták, értelmezték és
				mint akaratukkal mindenben megegyezőt elfogadták.
			</p>
		</section>
		<section>
			<h1>
				I. számú Melléklet
				<br />
				HOZZÁJÁRULÓ NYILATKOZAT SZEMÉLYES ADATOK KEZELÉSHEZ
			</h1>
			<p>
				Alulírott
				<span className="doc-form">
					<span className="doc-form__row">
						<span className="doc-form__label">Név:</span>
						<span className="doc-form__value"></span>
					</span>
					<span className="doc-form__row">
						<span className="doc-form__label">Lakcím:</span>
						<span className="doc-form__value"></span>
					</span>
					<span className="doc-form__row">
						<span className="doc-form__label">Anyja neve:</span>
						<span className="doc-form__value"></span>
					</span>
					<span className="doc-form__row">
						<span className="doc-form__label">
							Születési hely, idő:
						</span>
						<span className="doc-form__value"></span>
					</span>
					<span className="doc-form__row">
						<span className="doc-form__label">
							Személyigazolvány szám:
						</span>
						<span className="doc-form__value"></span>
					</span>
					<span className="doc-form__row">
						<span className="doc-form__label">TAJ azonosító:</span>
						<span className="doc-form__value"></span>
					</span>
				</span>
				a jelen nyilatkozat aláírásával kijelentem, hogy a
				szívtranszplantációs eljárást megelőző pretranszplantációs
				eljárás során rendelkezésemre bocsátott adatkezelési
				tájékoztatót megértettem, elolvastam, annak tartalmát
				megismertem, és kifejezetten hozzájárulok ahhoz, hogy a
				személyes és egészségügyi adataimat a betegellátás során
				<span className="doc-value"></span>, mint adatkezelő kezelje és
				tárolja a Szívtranszplantációs Döntéstámogató Rendszerben,
				egészségügyi szolgáltatásnyújtás és kapcsolatfelvétel céljából.
			</p>
			<p>
				Alulírott, <b>kifejezetten hozzájárulok</b> ahhoz, hogy a
				személyes adataimat a Transzplantációs Bizottság a betegellátás
				során megismerje, azokat kezelje.
			</p>
			<p>
				Alulírott, kifejezetten hozzájárulok ahhoz, hogy a
				Transzplantációs Bizottság és annak tagjai az{" "}
				<b>anonimizált adataimat</b> tudományos kutatási célra
				felhasználja, vagy ilyen célból harmadik személynek átadja.
			</p>
			<p>
				Kelt, 201
				<span className="doc-date-segment toc-date__year"></span>
				{" év "}
				<span className="doc-date-segment toc-date__month"></span>
				{" hónap "}
				<span className="doc-date-segment toc-date__day"></span>
				{" nap"}
			</p>
			<div className="doc-signature">
				a nyilatkozattevő olvasható neve és aláírása
			</div>
		</section>
	</TextDoc>
);
